import PromotionFlash from "features/FlashPromotion/PromotionFlashList/PromotionFlash";

const PromotionFlashesPage: React.FC = () => {
    return <PromotionFlash/>;
  };
  
  export default PromotionFlashesPage;